const defaultBeginPrefix = '/api';

export const VPN = `${defaultBeginPrefix}/vpn/radius_vpn_servers/`;
export const IS_PROD_API_HOST = process.env.VUE_APP_API_HOST === 'https://api.cp-appadmin.com';